import { render, staticRenderFns } from "./DefaultMailEditSend.vue?vue&type=template&id=a5215636&lang=pug&"
import script from "./DefaultMailEditSend.vue?vue&type=script&lang=ts&"
export * from "./DefaultMailEditSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports